/**
 * The pushpin artwork.
 *
 * Deliberately duplicated from render.php, which draws the same SVG for the
 * frontend. PHP cannot import this module and a ServerSideRender round-trip
 * would make every control feel laggy, so the two copies are the pragmatic
 * choice — but they will drift if only one is edited. Change both together.
 */
export default function Pin({ color }) {
  const style = color ? { '--note-pin-color': color } : undefined;

  return (
    <span className="brandy-pinned-note__pin" style={style} aria-hidden="true">
      <svg viewBox="0 0 32 40" width="28" height="35" focusable="false" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.4 26.6 14 38.4a.6.6 0 0 0 1.1.4l3.2-9.6z" fill="currentColor" opacity=".55" />
        <ellipse cx="16" cy="14" rx="11" ry="10.5" fill="currentColor" />
        <ellipse cx="12" cy="10" rx="3.4" ry="2.6" fill="#fff" opacity=".45" />
      </svg>
    </span>
  );
}
